import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, EyeOff, MessageSquareWarning, Target } from 'lucide-react';
export function Slide02AttentionWar() {
  const items = [{
    icon: MessageSquareWarning,
    text: 'Consumers bombarded with messages',
    delay: 0.2
  }, {
    icon: AlertCircle,
    text: 'Low trust in advertising',
    delay: 0.4
  }, {
    icon: EyeOff,
    text: "Visibility isn't enough - experiences needed",
    delay: 0.6
  }, {
    icon: Target,
    text: 'Sampling creates real product contact',
    delay: 0.8,
    highlight: true
  }];
  return <div className="flex flex-col h-full justify-center max-w-6xl mx-auto w-full" data-id="element-40">
      <motion.h2 className="text-5xl font-bold text-[#ffd700] mb-16 text-center" initial={{
      y: -50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} data-id="element-41">
        The Never‑Ending Attention War
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-42">
        <div className="relative h-96" data-id="element-43">
          {/* Abstract illustration of fish avoiding hooks */}
          <motion.div className="absolute inset-0 bg-gradient-to-br from-[#4fd1c5]/20 to-transparent rounded-3xl backdrop-blur-sm border border-white/10" initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} data-id="element-44">
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-45">
              <motion.div animate={{
              rotate: 360
            }} transition={{
              duration: 20,
              repeat: Infinity,
              ease: 'linear'
            }} className="w-64 h-64 border-2 border-dashed border-white/20 rounded-full" data-id="element-46" />
              <motion.div animate={{
              rotate: -360
            }} transition={{
              duration: 15,
              repeat: Infinity,
              ease: 'linear'
            }} className="absolute w-48 h-48 border-2 border-dashed border-[#ffd700]/30 rounded-full" data-id="element-47" />
            </div>
          </motion.div>
        </div>

        <div className="space-y-6" data-id="element-48">
          {items.map((item, i) => <motion.div key={i} initial={{
          x: 50,
          opacity: 0
        }} animate={{
          x: 0,
          opacity: 1
        }} transition={{
          delay: item.delay,
          type: 'spring'
        }} className={`flex items-center gap-6 p-6 rounded-xl border ${item.highlight ? 'bg-[#ffd700]/10 border-[#ffd700] text-[#ffd700]' : 'bg-white/5 border-white/10 text-white'}`} data-id="element-49">
              <item.icon className={`w-8 h-8 ${item.highlight ? 'text-[#ffd700]' : 'text-[#4fd1c5]'}`} data-id="element-50" />
              <span className="text-xl font-medium" data-id="element-51">{item.text}</span>
            </motion.div>)}
        </div>
      </div>
    </div>;
}